<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <!-- <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div> -->
        <form class="w-full" id="monitorForm" @submit.prevent>
          <div class="flex flex-wrap">
            <div
              v-if="!newMonitor"
              class="w-full text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            >
              Editar perfil
            </div>
            <div
              v-if="newMonitor"
              class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
            >
              Nuevo Monitorista
            </div>

            <div class="w-4/12">
              <div class="relative w-40 h-40">
                <!-- <img src="https://i.pravatar.cc/300" class="h-30 w-30 mt-1 rounded-full border-solid border-4 border-teal-500"> -->
                <img
                  :src="monitor.profile_image"
                  class="h-full w-full object-cover mt-1 rounded-full"
                  alt
                  v-bind:class="[
                    monitor.inactive
                      ? 'border-solid border-4 border-danger-color'
                      : 'border-solid border-4 border-primary-color',
                  ]"
                />
                <div
                  class="rounded-full h-12 w-12 absolute bottom-0 right-0 items-center justify-center bg-gray-200 hover:bg-gray-400 hover:text-gray-800 cursor-pointer border-solid border-4 border-white"
                >
                  <svg
                    class="m-2 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    heigth="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 20h9" />
                    <path
                      d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                    />
                  </svg>
                  <input
                    @change="changeImage"
                    class="cursor-pointer bottom-0 right-0 w-12 h-12 absolute block opacity-0 pin-r pin-t"
                    type="file"
                    name="profile_image"
                    accept="image/png, image/jpeg"
                  />
                </div>
              </div>
            </div>
            <div class="flex flex-col w-8/12 pl-4">
              <!-- <form class="w-full max-w-lg" id="monitorForm" @submit.prevent> -->
              <div class="w-full max-w-lg">
                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="name"
                      >Nombre *</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="name"
                      type="text"
                      name="name"
                      v-model="monitor.nombre"
                    />
                    <p v-if="errors.name" class="text-red-500 text-xs italic">
                      Ingrese su nombre.
                    </p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="last_name"
                      >Apellido *</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="last_name"
                      type="text"
                      name="last_name"
                      v-model="monitor.apellido"
                    />
                    <p
                      v-if="errors.lastname"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese su apellido.
                    </p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3" v-if="newMonitor">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="email"
                      >Correo *</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="email"
                      type="text"
                      name="email"
                      v-model="monitor.email"
                    />
                    <p v-if="errors.email" class="text-red-500 text-xs italic">
                      Ingrese un correo electrónico.
                    </p>
                    <p
                      v-if="errors.valid_email"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese un correo electrónico válido.
                    </p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3" v-if="newMonitor">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="password"
                      >Contraseña *</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="password"
                      type="password"
                      name="password"
                      v-model="password"
                    />
                    <p
                      v-if="errors.password"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese una contraseña.
                    </p>
                    <p
                      v-if="errors.valid_password"
                      class="text-red-500 text-xs italic"
                    >
                      La contraseña no coincide.
                    </p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3" v-if="newMonitor">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="password_again"
                      >Repetir Contraseña *</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="password_again"
                      type="password"
                      name="password_again"
                      v-model="password_again"
                    />
                    <p
                      v-if="errors.password_again"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese una contraseña.
                    </p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="sex"
                      >Sexo</label
                    >
                    <div class="relative">
                      <select
                        v-model="monitor.sexo"
                        name="sex"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option
                          v-for="(option, index) in options"
                          v-bind:value="option.value"
                          :key="index"
                        >
                          {{ option.text }}
                        </option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <!-- <p
                      v-if="errors.sex"
                      class="text-red-500 text-xs italic pt-3"
                    >
                      Seleccione un tipo de sexo.
                    </p> -->
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="age"
                      >Edad</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="age"
                      type="number"
                      min="18"
                      name="age"
                      v-model="monitor.edad"
                    />
                    <!-- <p v-if="errors.age" class="text-red-500 text-xs italic">
                      Ingrese una edad.
                    </p> -->
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="educationalLvl"
                      >Nivel de estudios</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="educationalLvl"
                      type="text"
                      v-model="monitor.nivel_estudios"
                    />
                    <!-- <p
                      v-if="errors.educationalLvl"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese un nivel de estudios.
                    </p> -->
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="language"
                      >Idioma</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="language"
                      type="text"
                      v-model="monitor.idioma"
                    />
                    <!-- <p
                      v-if="errors.language"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese un idioma.
                    </p> -->
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="occupation"
                      >Ocupación</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="occupation"
                      type="text"
                      v-model="monitor.ocupacion"
                    />
                    <!-- <p
                      v-if="errors.occupation"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese una ocupación.
                    </p> -->
                  </div>
                </div>

                <div
                  class="flex flex-wrap -mx-3"
                  v-if="viewModal == 'monitor_list'"
                >
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="isAdmin"
                      >Administrador</label
                    >
                    <div
                      id="isAdmin"
                      class="w-12 h-6 rounded-full shadow inline-block cursor-pointer mr-64"
                      v-bind:class="[
                        monitor.is_admin ? 'bg-green-500' : 'bg-grey-600',
                      ]"
                      v-on:click="monitor.is_admin = !monitor.is_admin"
                    >
                      <div
                        class="w-1/2 h-full rounded-full shadow bg-white"
                        :style="{
                          transform: `translateX(${
                            monitor.is_admin ? 100 : 0
                          }%)`,
                        }"
                      ></div>
                    </div>
                  </div>
                </div>

                <div class="flex w-full justify-end mt-3">
                  <button
                    class="bg-secondary-color hover:bg-secondary-color-dark px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="saveAuthority()"
                  >
                    Guardar
                  </button>
                  <button
                    class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="close()"
                  >
                    Cerrar
                  </button>
                </div>
                <!-- </form> -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Perfil actualizado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errors.codeError }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

export default {
  name: "monitor-modal",
  data() {
    return {
      aux_monitor: null,
      monitor: {
        name: null,
        last_name: null,
        address: null,
        phone_number: null,
        age: null,
        sex: null,
        id: null,
        is_admin: false,
        profile_image:
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png",
      },
      options: [
        { text: "Hombre", value: "H" },
        { text: "Mujer", value: "M" },
      ],
      errors: {
        email: false,
        valid_email: false,
        name: false,
        lastname: false,
        phone: false,
        age: false,
        valid_phone: false,
        address: false,
        sex: false,
        educationLvl: false,
        language: false,
        occupation: false,
        password: false,
        password_again: false,
        valid_password: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      password_again: null,
      password: null,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    newMonitor: {
      required: true,
      type: Boolean,
    },
    viewModal: {
      required: true,
      type: String,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.monitor = {
        name: null,
        last_name: null,
        address: null,
        phone_number: null,
        age: null,
        sex: null,
        id: null,
        email: null,
        is_admin: null,
        profile_image:
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png",
      };
      this.errors = {
        email: false,
        valid_email: false,
        name: false,
        lastname: false,
        phone: false,
        age: false,
        auth_id: false,
        valid_phone: false,
        address: false,
        sex: false,
        educationLvl: false,
        language: false,
        occupation: false,
        password: false,
        password_again: false,
        valid_password: false,
        codeError: "Ha ocurrido un error",
      };
      (this.password_again = null), (this.password = null);
    },

    close() {
      this.reset();
      this.$emit("close");
    },
    changeImage: function (event) {
      const file = event.target.files[0];
      this.monitor.profile_image = URL.createObjectURL(file);
    },

    setData: function (monitor) {
      this.monitor = Object.assign({}, monitor);
      this.aux_monitor = Object.assign({}, monitor);
    },

    saveAuthority() {
      this.$root.$emit("showLoading");

      const inputAge = document.getElementById("age").value;
      if (inputAge >= 18) {
        const form = document.getElementById("monitorForm");
        const formData = new FormData(form);

        if (this.newMonitor) {
          const validForm = this.checkFormNewMonitor(formData);
          if (validForm) {
            formData.append("type", "monitor");
            formData.append("is_admin", this.monitor.is_admin);
            formData.delete("profile_image");
            //implement code for create new monitor
            this.axios
              .post(
                "apidev/users",
                formData,
                // {
                //   type: "monitor",
                //   email: this.monitor.email,
                //   password: this.password,
                //   name: this.monitor.name,
                //   last_name: this.monitor.last_name,
                //   address: this.monitor.address,
                //   phone_number: this.monitor.phone_number,
                //   age: this.monitor.age,
                //   sex: this.monitor.sex,
                //   is_admin: this.monitor.is_admin
                // },
                this.config
              )
              .then((response) => {
                const formImageData = new FormData(form);
                const profile_image = formImageData.get("profile_image");
                const mimeType = this.checkMimeType(profile_image);
                const newDate = Date.now();
                const nameFile =
                  "profile_image_" +
                  response.data.user.username.replace(".", "_") +
                  "_" +
                  response.data.user.username_id +
                  "_" +
                  newDate +
                  mimeType;
                if (profile_image && profile_image.name != "") {
                  formImageData.set("profile_image", profile_image, nameFile);

                  formImageData.append("user_id", response.data.user.id);

                  return this.axios.post(
                    "apidev/users/update_profile_image",
                    formImageData,
                    this.config
                  );
                } else {
                  return Promise.resolve();
                }
              })
              .then((response) => {
                this.showingSuccess = true;
                this.$emit("updateAllMonitors");
                this.reset();
                this.$emit("close");
                this.$root.$emit("hideLoading");
              })
              .catch((error) => {
                // removed console log
                if (error.response.status == 409) {
                  this.errors.codeError =
                    "Ya hay otra persona que tiene esta dirección de correo electrónico. Pruebe con otro correo";
                }
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
                this.showingError = true;
                this.$root.$emit("hideLoading");
              });
          }
        } else {
          const validForm = this.checkFormUpdateMonitor(formData);
          if (validForm) {
            let newDate = Date.now();
            const profile_image = formData.get("profile_image");
            const mimeType = this.checkMimeType(profile_image);
            if (profile_image && profile_image.name != "") {
              formData.set(
                "profile_image",
                profile_image,
                "profile_image_" +
                  this.monitor.user_id.replace(".", "_") +
                  "_" +
                  newDate +
                  mimeType
              );
            }
            formData.append("is_admin", this.monitor.is_admin);
            formData.append("user_id", this.monitor.user_id);

            this.axios
              .post("apidev/users/edituser", this.monitor, this.config)
              .then((response) => {
                let observation = "";
                if (
                  this.monitor.name != this.aux_monitor.name ||
                  this.monitor.last_name != this.aux_monitor.last_name
                ) {
                  observation = `${this.aux_monitor.name} ${this.aux_monitor.last_name} / ${this.monitor.name} ${this.monitor.last_name}`;
                } else {
                  observation = `${this.monitor.name} ${this.monitor.last_name}`;
                }

                return this.axios.post(
                    "apidev/users/update_profile_image",
                    formData,
                    this.config
                  );
              
              })
              .then((response) => {
                this.showingSuccess = true;
                this.$emit("updateMonitor", this.monitor);
                this.reset();
                this.$emit("close");
                this.$root.$emit("hideLoading");
              })
              .catch((error) => {
                // removed console log
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
                this.showingError = true;
                this.$root.$emit("hideLoading");
              });
          }
        }
      } else {
        alert("La edad debe ser mayor o igual a 18 años");
      }
    },

    checkFormNewMonitor: function (data) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var rePhone = /^([0-9])*$/;

      if (data.get("email") === "") {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }

      if (!re.test(data.get("email"))) {
        this.errors.valid_email = this.errors.email ? false : true;
      } else {
        this.errors.valid_email = false;
      }

      if (data.get("password") === "") {
        this.errors.password = true;
      } else {
        this.errors.password = false;
      }

      if (data.get("password_again") === "") {
        this.errors.password_again = true;
      } else {
        this.errors.password_again = false;
      }

      if (data.get("password") !== data.get("password_again")) {
        this.errors.valid_password = true;
        return false;
      } else {
        this.errors.valid_password = false;
      }

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("last_name") === "") {
        this.errors.lastname = true;
      } else {
        this.errors.lastname = false;
      }

      if (data.get("age") === "") {
        this.errors.age = true;
      } else {
        this.errors.age = false;
      }

      if (data.get("sex") === null) {
        this.errors.sex = true;
      } else {
        this.errors.sex = false;
      }

      if (
        this.errors.email ||
        this.errors.valid_email ||
        this.errors.password ||
        this.errors.password_again ||
        this.errors.valid_password ||
        this.errors.name ||
        this.errors.lastname ||
        this.errors.phone ||
        this.errors.valid_phone ||
        this.errors.address ||
        this.errors.age ||
        this.errors.sex
      ) {
        return false;
      }

      return true;
    },

    checkFormUpdateMonitor: function (data) {
      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("last_name") === "") {
        this.errors.lastname = true;
      } else {
        this.errors.lastname = false;
      }

      if (this.errors.name || this.errors.lastname) {
        return false;
      }

      return true;
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
